export const TRACKING_QUERY_PARAMS_STORAGE_KEY = "agelessai:tracking-query-params";

export const KNOWN_ATTRIBUTION_QUERY_KEYS = new Set<string>([
  "gclid",
  "fbclid",
  "msclkid",
  "ttclid",
  "twclid",
  "dclid",
  "yclid",
  "gbraid",
  "wbraid",
  "li_fat_id",
  "mc_cid",
  "mc_eid",
  "rdt_cid",
  "sccid",
  "irclickid",
  "ref",
  "refid",
  "referrer",
  "source",
  "campaign",
  "medium",
  "term",
  "content",
  "keyword",
  "adgroup",
  "adid",
  "creative",
  "placement",
  "network",
  "matchtype",
  "device",
  "goldcasteventid",
]);
